export const stakeholders = [
  "Farmers",
  "FPOs",
  "Cooperatives",
  "Buyers",
  "Input Suppliers",
  "Logistics Providers",
  "Banks",
  "NBFCs",
  "Government Agencies",
];

export const languages = {
  en: {
    name: "English",
    nav: { ecosystem: "Ecosystem", finance: "Finance", governance: "Governance", demo: "Request a Demo" },
    heroEyebrow: "Digital Management Engine for Agricultural Value Chains",
    heroTitle: "The Digital Infrastructure for Agricultural Value Chains",
    heroSubtitle: "Connecting Farmers, FPOs, Cooperatives, Buyers and Financial Institutions through a unified ecosystem for collaboration, commerce, governance and finance.",
    explore: "Explore Platform",
    form: {
      title: "Request a Valchain AgriHub Demo",
      description: "Share a few details and we’ll shape the walkthrough around your institution, value chain, and financing goals.",
      name: "Full name",
      organization: "Organization",
      email: "Work email",
      interest: "What would you like to explore?",
      submit: "Send Demo Request",
      sending: "Sending Request...",
      successTitle: "Your demo request is ready.",
      successCopy: "Thank you — the request has been received and is ready for the Valchain team.",
      close: "Close",
      placeholders: {
        name: "Your name",
        organization: "FPO, cooperative, bank, agency...",
        email: "name@organization.com",
        interest: "Discovery, marketplace operations, value chain financing, event-based disbursement...",
      },
    },
    storySteps: ["Discover", "Collaborate", "Transact", "Verified Data", "Finance", "Growth"],
    sections: {
      challenge: { eyebrow: "The Challenge", title: "Agriculture Runs on Relationships. Most Systems Run in Silos." },
      ecosystem: { eyebrow: "One ecosystem. Every stakeholder.", title: "A connected operating layer for agricultural institutions, commerce, finance and oversight." },
      journey: { eyebrow: "Signature Platform Flow", title: "Discover • Collaborate • Transact", copy: "Discovery creates opportunities. Collaboration creates trust. Transactions create verified data. Verified data enables financing. Financing drives growth." },
      commerce: { eyebrow: "Marketplace & Commerce", title: "Built for Agricultural Trade", copy: "A commerce operating layer where discovery flows into aggregation, contracts, orders and digital settlements." },
      finance: { eyebrow: "Value Chain Financing", title: "Finance Built Around Real Agricultural Activity", copy: "Traditional lending depends on collateral. Valchain AgriHub enables financing using verified activities and transactions occurring across the agricultural value chain." },
      disbursement: { eyebrow: "Event-Based Disbursement", title: "Funds Released When Real Events Occur", copy: "Capital is released against verified milestones rather than being disbursed upfront." },
      traceability: { eyebrow: "Traceability & Transparency", title: "Trust Built Into Every Transaction" },
      governance: { eyebrow: "Governance & Compliance", title: "Digital Governance for Modern Institutions" },
      cooperatives: { eyebrow: "Built for FPOs & Cooperatives", title: "Strengthening Collective Agriculture" },
      impact: { eyebrow: "Growth & Impact", title: "Outcomes That Matter" },
      finalCta: { eyebrow: "Unified Agricultural Ecosystem", title: "Build Stronger Agricultural Value Chains That Grow Like The Nature", copy: "Empower Farmers. Strengthen Institutions. Unlock Finance." },
    },
    challenges: ["Fragmented farmers", "Isolated FPOs", "Disconnected cooperatives", "Poor market access", "Limited financing", "Manual operations", "Lack of transparency", "Lack of traceability"],
    stakeholders: ["Farmers", "FPOs", "Cooperatives", "Buyers", "Input Suppliers", "Logistics Providers", "Banks", "NBFCs", "Government Agencies"],
    journey: {
      Discover: ["Discover farmers", "Discover buyers", "Discover suppliers", "Discover FPOs", "Discover cooperatives", "Discover opportunities", "Discover ecosystem partners"],
      Collaborate: ["Collective procurement", "Shared logistics", "Stakeholder engagement", "Group planning", "Communication workflows", "Knowledge sharing"],
      Transact: ["B2B Marketplace", "B2C Marketplace", "Procurement", "Sales", "Contract Management", "Digital Payments", "Settlements", "Traceability", "Governance Records"],
    },
    commerceCapabilities: ["Buyer Discovery", "Supplier Discovery", "Aggregation", "Procurement", "Bulk Trading", "Contract Management", "Order Management", "Digital Settlements"],
    financeBenefits: ["Better credit access", "Reduced risk", "Faster working capital", "Data-driven underwriting", "Financial inclusion", "Greater lender confidence"],
    disbursementMilestones: [["Farmer Registration", "Initial Disbursement"], ["Input Purchase", "Input Finance Released"], ["Crop Verification", "Working Capital Released"], ["Aggregation Completed", "Procurement Finance Released"], ["Buyer Contract Signed", "Trade Finance Released"], ["Delivery Confirmed", "Settlement Triggered"], ["Payment Received", "Cycle Completed"]],
    traceabilitySteps: ["Farm Registration", "Geo-tagging", "Production Tracking", "Quality Verification", "Aggregation", "Logistics", "Delivery", "Settlement"],
    governanceCapabilities: ["Member Management", "Board Management", "Audit Trails", "Reporting", "Compliance", "Transparency", "Digital Records"],
    cooperativeOutcomes: ["Better coordination", "Better governance", "Better market access", "Better financing", "Better transparency", "Sustainable growth"],
    impactMetrics: [["Farmer Prosperity", "Stronger incomes through connected demand"], ["Market Access", "Verified discovery for buyers and suppliers"], ["Institutional Growth", "FPOs and cooperatives operating with confidence"], ["Financial Inclusion", "Credit enabled by real activity data"], ["Value Chain Efficiency", "Less duplication, faster movement"], ["Transaction Transparency", "Governed records across every milestone"]],
  },
  hi: {
    name: "हिन्दी",
    nav: { ecosystem: "इकोसिस्टम", finance: "वित्त", governance: "गवर्नेंस", demo: "डेमो अनुरोध" },
    heroEyebrow: "कृषि वैल्यू चेन के लिए डिजिटल मैनेजमेंट इंजन",
    heroTitle: "कृषि वैल्यू चेन के लिए डिजिटल इंफ्रास्ट्रक्चर",
    heroSubtitle: "किसानों, FPOs, सहकारी संस्थाओं, खरीदारों और वित्तीय संस्थानों को सहयोग, वाणिज्य, गवर्नेंस और वित्त के एकीकृत इकोसिस्टम से जोड़ता है।",
    explore: "प्लेटफ़ॉर्म देखें",
    form: {
      title: "Valchain AgriHub डेमो अनुरोध",
      description: "कुछ विवरण साझा करें और हम आपकी संस्था, वैल्यू चेन और वित्तीय लक्ष्यों के अनुसार डेमो तैयार करेंगे।",
      name: "पूरा नाम",
      organization: "संगठन",
      email: "कार्य ईमेल",
      interest: "आप क्या देखना चाहेंगे?",
      submit: "डेमो अनुरोध भेजें",
      sending: "अनुरोध भेजा जा रहा है...",
      successTitle: "आपका डेमो अनुरोध तैयार है।",
      successCopy: "धन्यवाद — अनुरोध प्राप्त हो गया है और Valchain टीम के लिए तैयार है।",
      close: "बंद करें",
      placeholders: { name: "आपका नाम", organization: "FPO, सहकारी, बैंक, एजेंसी...", email: "name@organization.com", interest: "डिस्कवरी, मार्केटप्लेस, वैल्यू चेन फाइनेंसिंग..." },
    },
    storySteps: ["खोज", "सहयोग", "लेन-देन", "सत्यापित डेटा", "वित्त", "विकास"],
    sections: {
      challenge: { eyebrow: "चुनौती", title: "कृषि रिश्तों पर चलती है। अधिकतर सिस्टम अलग-अलग साइलो में चलते हैं।" },
      ecosystem: { eyebrow: "एक इकोसिस्टम। हर हितधारक।", title: "कृषि संस्थाओं, व्यापार, वित्त और निगरानी के लिए जुड़ा हुआ ऑपरेटिंग लेयर।" },
      journey: { eyebrow: "मुख्य प्लेटफ़ॉर्म प्रवाह", title: "खोज • सहयोग • लेन-देन", copy: "खोज अवसर बनाती है। सहयोग भरोसा बनाता है। लेन-देन सत्यापित डेटा बनाता है। सत्यापित डेटा वित्त को सक्षम करता है। वित्त विकास को गति देता है।" },
      commerce: { eyebrow: "मार्केटप्लेस और कॉमर्स", title: "कृषि व्यापार के लिए निर्मित", copy: "एक कॉमर्स ऑपरेटिंग लेयर जहाँ खोज से एग्रीगेशन, कॉन्ट्रैक्ट, ऑर्डर और डिजिटल सेटलमेंट तक प्रवाह बनता है।" },
      finance: { eyebrow: "वैल्यू चेन फाइनेंसिंग", title: "वास्तविक कृषि गतिविधि पर आधारित वित्त", copy: "पारंपरिक ऋण गारंटी पर निर्भर करता है। Valchain AgriHub कृषि वैल्यू चेन में होने वाली सत्यापित गतिविधियों और लेन-देन के आधार पर वित्त को सक्षम करता है।" },
      disbursement: { eyebrow: "इवेंट-आधारित डिस्बर्समेंट", title: "वास्तविक घटनाएँ होने पर फंड जारी होते हैं", copy: "पूंजी अग्रिम रूप से नहीं, बल्कि सत्यापित माइलस्टोन के आधार पर जारी होती है।" },
      traceability: { eyebrow: "ट्रेसेबिलिटी और पारदर्शिता", title: "हर लेन-देन में भरोसा" },
      governance: { eyebrow: "गवर्नेंस और अनुपालन", title: "आधुनिक संस्थाओं के लिए डिजिटल गवर्नेंस" },
      cooperatives: { eyebrow: "FPOs और सहकारी संस्थाओं के लिए", title: "सामूहिक कृषि को मजबूत बनाना" },
      impact: { eyebrow: "विकास और प्रभाव", title: "महत्वपूर्ण परिणाम" },
      finalCta: { eyebrow: "एकीकृत कृषि इकोसिस्टम", title: "मजबूत कृषि वैल्यू चेन बनाएं", copy: "किसानों को सशक्त करें। संस्थाओं को मजबूत करें। वित्त को अनलॉक करें।" },
    },
    challenges: ["बिखरे हुए किसान", "अलग-थलग FPOs", "असंबद्ध सहकारी संस्थाएँ", "कम बाज़ार पहुँच", "सीमित वित्त", "मैनुअल संचालन", "पारदर्शिता की कमी", "ट्रेसेबिलिटी की कमी"],
    stakeholders: ["किसान", "FPOs", "सहकारी संस्थाएँ", "खरीदार", "इनपुट सप्लायर", "लॉजिस्टिक्स प्रदाता", "बैंक", "NBFCs", "सरकारी एजेंसियाँ"],
    journey: { खोज: ["किसानों की खोज", "खरीदारों की खोज", "सप्लायरों की खोज", "FPOs की खोज", "सहकारी संस्थाओं की खोज", "अवसरों की खोज", "इकोसिस्टम भागीदारों की खोज"], सहयोग: ["सामूहिक खरीद", "साझा लॉजिस्टिक्स", "हितधारक सहभागिता", "समूह योजना", "संचार वर्कफ़्लो", "ज्ञान साझा करना"], लेनदेन: ["B2B मार्केटप्लेस", "B2C मार्केटप्लेस", "प्रोक्योरमेंट", "बिक्री", "कॉन्ट्रैक्ट प्रबंधन", "डिजिटल भुगतान", "सेटलमेंट", "ट्रेसेबिलिटी", "गवर्नेंस रिकॉर्ड"] },
    commerceCapabilities: ["खरीदार खोज", "सप्लायर खोज", "एग्रीगेशन", "प्रोक्योरमेंट", "बल्क ट्रेडिंग", "कॉन्ट्रैक्ट प्रबंधन", "ऑर्डर प्रबंधन", "डिजिटल सेटलमेंट"],
    financeBenefits: ["बेहतर क्रेडिट पहुँच", "कम जोखिम", "तेज़ कार्यशील पूंजी", "डेटा-आधारित अंडरराइटिंग", "वित्तीय समावेशन", "ऋणदाता का अधिक भरोसा"],
    disbursementMilestones: [["किसान पंजीकरण", "प्रारंभिक डिस्बर्समेंट"], ["इनपुट खरीद", "इनपुट वित्त जारी"], ["फसल सत्यापन", "कार्यशील पूंजी जारी"], ["एग्रीगेशन पूर्ण", "प्रोक्योरमेंट वित्त जारी"], ["खरीदार कॉन्ट्रैक्ट हस्ताक्षरित", "ट्रेड वित्त जारी"], ["डिलीवरी पुष्टि", "सेटलमेंट ट्रिगर"], ["भुगतान प्राप्त", "चक्र पूर्ण"]],
    traceabilitySteps: ["फार्म पंजीकरण", "जियो-टैगिंग", "उत्पादन ट्रैकिंग", "गुणवत्ता सत्यापन", "एग्रीगेशन", "लॉजिस्टिक्स", "डिलीवरी", "सेटलमेंट"],
    governanceCapabilities: ["सदस्य प्रबंधन", "बोर्ड प्रबंधन", "ऑडिट ट्रेल", "रिपोर्टिंग", "अनुपालन", "पारदर्शिता", "डिजिटल रिकॉर्ड"],
    cooperativeOutcomes: ["बेहतर समन्वय", "बेहतर गवर्नेंस", "बेहतर बाज़ार पहुँच", "बेहतर वित्त", "बेहतर पारदर्शिता", "सतत विकास"],
    impactMetrics: [["किसान समृद्धि", "जुड़ी हुई मांग से मजबूत आय"], ["बाज़ार पहुँच", "खरीदारों और सप्लायरों के लिए सत्यापित खोज"], ["संस्थागत विकास", "FPOs और सहकारी संस्थाएँ आत्मविश्वास से संचालन करती हैं"], ["वित्तीय समावेशन", "वास्तविक गतिविधि डेटा से क्रेडिट"], ["वैल्यू चेन दक्षता", "कम दोहराव, तेज़ गति"], ["लेन-देन पारदर्शिता", "हर माइलस्टोन पर गवर्न रिकॉर्ड"]],
  },
  te: {
    name: "తెలుగు",
    nav: { ecosystem: "ఎకోసిస్టమ్", finance: "ఫైనాన్స్", governance: "గవర్నెన్స్", demo: "డెమో కోరండి" },
    heroEyebrow: "వ్యవసాయ విలువ గొలుసుల కోసం డిజిటల్ మేనేజ్‌మెంట్ ఇంజిన్",
    heroTitle: "వ్యవసాయ విలువ గొలుసుల కోసం డిజిటల్ మౌలిక వసతులు",
    heroSubtitle: "రైతులు, FPOలు, సహకార సంఘాలు, కొనుగోలుదారులు మరియు ఆర్థిక సంస్థలను సహకారం, వాణిజ్యం, గవర్నెన్స్ మరియు ఫైనాన్స్ కోసం ఒకే ఎకోసిస్టమ్‌లో కలుపుతుంది.",
    explore: "ప్లాట్‌ఫారమ్ చూడండి",
    form: {
      title: "Valchain AgriHub డెమో అభ్యర్థన",
      description: "కొన్ని వివరాలు పంచుకోండి; మీ సంస్థ, విలువ గొలుసు మరియు ఫైనాన్స్ లక్ష్యాలకు అనుగుణంగా వాక్‌థ్రూ సిద్ధం చేస్తాం.",
      name: "పూర్తి పేరు",
      organization: "సంస్థ",
      email: "వర్క్ ఇమెయిల్",
      interest: "మీరు ఏమి చూడాలనుకుంటున్నారు?",
      submit: "డెమో అభ్యర్థన పంపండి",
      sending: "అభ్యర్థన పంపుతోంది...",
      successTitle: "మీ డెమో అభ్యర్థన సిద్ధంగా ఉంది.",
      successCopy: "ధన్యవాదాలు — అభ్యర్థన స్వీకరించబడింది మరియు Valchain టీమ్‌కు సిద్ధంగా ఉంది.",
      close: "మూసివేయండి",
      placeholders: { name: "మీ పేరు", organization: "FPO, సహకార సంఘం, బ్యాంక్, ఏజెన్సీ...", email: "name@organization.com", interest: "డిస్కవరీ, మార్కెట్‌ప్లేస్, విలువ గొలుసు ఫైనాన్స్..." },
    },
    storySteps: ["కనుగొనండి", "సహకరించండి", "లావాదేవీ", "ధృవీకరించిన డేటా", "ఫైనాన్స్", "వృద్ధి"],
    sections: {
      challenge: { eyebrow: "సవాలు", title: "వ్యవసాయం సంబంధాలపై నడుస్తుంది. చాలా వ్యవస్థలు విడిగా పనిచేస్తాయి." },
      ecosystem: { eyebrow: "ఒక ఎకోసిస్టమ్. ప్రతి భాగస్వామి.", title: "వ్యవసాయ సంస్థలు, వాణిజ్యం, ఫైనాన్స్ మరియు పర్యవేక్షణ కోసం కలిపిన ఆపరేటింగ్ లేయర్." },
      journey: { eyebrow: "ప్రధాన ప్లాట్‌ఫారమ్ ప్రవాహం", title: "కనుగొనండి • సహకరించండి • లావాదేవీ చేయండి", copy: "డిస్కవరీ అవకాశాలను సృష్టిస్తుంది. సహకారం నమ్మకాన్ని సృష్టిస్తుంది. లావాదేవీలు ధృవీకరించిన డేటాను సృష్టిస్తాయి. ఆ డేటా ఫైనాన్స్‌ను సాధ్యం చేస్తుంది. ఫైనాన్స్ వృద్ధిని నడిపిస్తుంది." },
      commerce: { eyebrow: "మార్కెట్‌ప్లేస్ & కామర్స్", title: "వ్యవసాయ వాణిజ్యం కోసం నిర్మించబడింది", copy: "డిస్కవరీ నుంచి అగ్రిగేషన్, ఒప్పందాలు, ఆర్డర్లు మరియు డిజిటల్ సెటిల్‌మెంట్‌ల వరకు నడిచే వాణిజ్య ఆపరేటింగ్ లేయర్." },
      finance: { eyebrow: "విలువ గొలుసు ఫైనాన్సింగ్", title: "నిజమైన వ్యవసాయ కార్యకలాపాల చుట్టూ నిర్మించిన ఫైనాన్స్", copy: "సాంప్రదాయ రుణాలు కొలాటరల్‌పై ఆధారపడతాయి. Valchain AgriHub వ్యవసాయ విలువ గొలుసులో జరిగే ధృవీకరించిన కార్యకలాపాలు మరియు లావాదేవీల ఆధారంగా ఫైనాన్స్‌ను సాధ్యం చేస్తుంది." },
      disbursement: { eyebrow: "ఈవెంట్-ఆధారిత విడుదల", title: "నిజమైన సంఘటనలు జరిగినప్పుడు నిధులు విడుదల", copy: "నిధులు ముందుగా పూర్తిగా విడుదల కావు; ధృవీకరించిన మైలురాళ్ల ఆధారంగా విడుదల అవుతాయి." },
      traceability: { eyebrow: "ట్రేసబిలిటీ & పారదర్శకత", title: "ప్రతి లావాదేవీలో నమ్మకం" },
      governance: { eyebrow: "గవర్నెన్స్ & కంప్లయన్స్", title: "ఆధునిక సంస్థల కోసం డిజిటల్ గవర్నెన్స్" },
      cooperatives: { eyebrow: "FPOలు & సహకార సంఘాల కోసం", title: "సమూహ వ్యవసాయాన్ని బలోపేతం చేయడం" },
      impact: { eyebrow: "వృద్ధి & ప్రభావం", title: "ముఖ్యమైన ఫలితాలు" },
      finalCta: { eyebrow: "ఏకీకృత వ్యవసాయ ఎకోసిస్టమ్", title: "బలమైన వ్యవసాయ విలువ గొలుసులను నిర్మించండి", copy: "రైతులను శక్తివంతం చేయండి. సంస్థలను బలోపేతం చేయండి. ఫైనాన్స్‌ను అందుబాటులోకి తెచ్చండి." },
    },
    challenges: ["విభజిత రైతులు", "ఒంటరిగా పనిచేసే FPOలు", "కలవని సహకార సంఘాలు", "తక్కువ మార్కెట్ ప్రాప్యత", "పరిమిత ఫైనాన్స్", "మాన్యువల్ కార్యకలాపాలు", "పారదర్శకత లోపం", "ట్రేసబిలిటీ లోపం"],
    stakeholders: ["రైతులు", "FPOలు", "సహకార సంఘాలు", "కొనుగోలుదారులు", "ఇన్‌పుట్ సరఫరాదారులు", "లాజిస్టిక్స్ ప్రొవైడర్లు", "బ్యాంకులు", "NBFCలు", "ప్రభుత్వ ఏజెన్సీలు"],
    journey: { కనుగొనండి: ["రైతులను కనుగొనండి", "కొనుగోలుదారులను కనుగొనండి", "సరఫరాదారులను కనుగొనండి", "FPOలను కనుగొనండి", "సహకార సంఘాలను కనుగొనండి", "అవకాశాలను కనుగొనండి", "ఎకోసిస్టమ్ భాగస్వాములను కనుగొనండి"], సహకరించండి: ["సమూహ కొనుగోలు", "పంచుకున్న లాజిస్టిక్స్", "భాగస్వామి ఎంగేజ్‌మెంట్", "గ్రూప్ ప్లానింగ్", "కమ్యూనికేషన్ వర్క్‌ఫ్లోలు", "జ్ఞాన భాగస్వామ్యం"], లావాదేవీ: ["B2B మార్కెట్‌ప్లేస్", "B2C మార్కెట్‌ప్లేస్", "ప్రొక్యూర్‌మెంట్", "అమ్మకాలు", "ఒప్పంద నిర్వహణ", "డిజిటల్ చెల్లింపులు", "సెటిల్‌మెంట్‌లు", "ట్రేసబిలిటీ", "గవర్నెన్స్ రికార్డులు"] },
    commerceCapabilities: ["కొనుగోలుదారు డిస్కవరీ", "సరఫరాదారు డిస్కవరీ", "అగ్రిగేషన్", "ప్రొక్యూర్‌మెంట్", "బల్క్ ట్రేడింగ్", "ఒప్పంద నిర్వహణ", "ఆర్డర్ నిర్వహణ", "డిజిటల్ సెటిల్‌మెంట్‌లు"],
    financeBenefits: ["మెరుగైన క్రెడిట్ ప్రాప్యత", "తగ్గిన ప్రమాదం", "వేగవంతమైన వర్కింగ్ క్యాపిటల్", "డేటా ఆధారిత అండర్‌రైటింగ్", "ఆర్థిక చేర్పు", "రుణదాత నమ్మకం పెరుగుతుంది"],
    disbursementMilestones: [["రైతు నమోదు", "ప్రాథమిక విడుదల"], ["ఇన్‌పుట్ కొనుగోలు", "ఇన్‌పుట్ ఫైనాన్స్ విడుదల"], ["పంట ధృవీకరణ", "వర్కింగ్ క్యాపిటల్ విడుదల"], ["అగ్రిగేషన్ పూర్తయింది", "ప్రొక్యూర్‌మెంట్ ఫైనాన్స్ విడుదల"], ["కొనుగోలుదారు ఒప్పందం సంతకం", "ట్రేడ్ ఫైనాన్స్ విడుదల"], ["డెలివరీ ధృవీకరణ", "సెటిల్‌మెంట్ ట్రిగర్"], ["చెల్లింపు స్వీకరణ", "చక్రం పూర్తి"]],
    traceabilitySteps: ["ఫార్మ్ నమోదు", "జియో-ట్యాగింగ్", "ఉత్పత్తి ట్రాకింగ్", "నాణ్యత ధృవీకరణ", "అగ్రిగేషన్", "లాజిస్టిక్స్", "డెలివరీ", "సెటిల్‌మెంట్"],
    governanceCapabilities: ["సభ్యుల నిర్వహణ", "బోర్డు నిర్వహణ", "ఆడిట్ ట్రెయిల్స్", "రిపోర్టింగ్", "కంప్లయన్స్", "పారదర్శకత", "డిజిటల్ రికార్డులు"],
    cooperativeOutcomes: ["మెరుగైన సమన్వయం", "మెరుగైన గవర్నెన్స్", "మెరుగైన మార్కెట్ ప్రాప్యత", "మెరుగైన ఫైనాన్స్", "మెరుగైన పారదర్శకత", "స్థిరమైన వృద్ధి"],
    impactMetrics: [["రైతు అభివృద్ధి", "కలిపిన డిమాండ్ ద్వారా బలమైన ఆదాయం"], ["మార్కెట్ ప్రాప్యత", "కొనుగోలుదారులు మరియు సరఫరాదారులకు ధృవీకరించిన డిస్కవరీ"], ["సంస్థాగత వృద్ధి", "FPOలు మరియు సహకార సంఘాలు నమ్మకంగా పనిచేయడం"], ["ఆర్థిక చేర్పు", "నిజమైన కార్యకలాపాల డేటాతో క్రెడిట్"], ["విలువ గొలుసు సామర్థ్యం", "తక్కువ డూప్లికేషన్, వేగవంతమైన కదలిక"], ["లావాదేవీ పారదర్శకత", "ప్రతి మైలురాయిలో గవర్న్డ్ రికార్డులు"]],
  },
  ta: {
    name: "தமிழ்",
    nav: { ecosystem: "சூழலமைப்பு", finance: "நிதி", governance: "நிர்வாகம்", demo: "டெமோ கோரவும்" },
    heroEyebrow: "விவசாய மதிப்பு சங்கிலிகளுக்கான டிஜிட்டல் மேலாண்மை இயந்திரம்",
    heroTitle: "விவசாய மதிப்பு சங்கிலிகளுக்கான டிஜிட்டல் உட்கட்டமைப்பு",
    heroSubtitle: "விவசாயிகள், FPOகள், கூட்டுறவுகள், வாங்குபவர்கள் மற்றும் நிதி நிறுவனங்களை ஒத்துழைப்பு, வர்த்தகம், நிர்வாகம் மற்றும் நிதிக்கான ஒருங்கிணைந்த சூழலமைப்பில் இணைக்கிறது.",
    explore: "பிளாட்ஃபார்மை பார்க்கவும்",
    form: {
      title: "Valchain AgriHub டெமோ கோரிக்கை",
      description: "சில விவரங்களை பகிருங்கள்; உங்கள் நிறுவனம், மதிப்பு சங்கிலி மற்றும் நிதி இலக்குகளுக்கேற்ப விளக்கத்தை அமைப்போம்.",
      name: "முழு பெயர்",
      organization: "நிறுவனம்",
      email: "வேலை மின்னஞ்சல்",
      interest: "நீங்கள் என்ன பார்க்க விரும்புகிறீர்கள்?",
      submit: "டெமோ கோரிக்கையை அனுப்பவும்",
      sending: "கோரிக்கை அனுப்பப்படுகிறது...",
      successTitle: "உங்கள் டெமோ கோரிக்கை தயாராக உள்ளது.",
      successCopy: "நன்றி — கோரிக்கை பெறப்பட்டது மற்றும் Valchain குழுவிற்கு தயாராக உள்ளது.",
      close: "மூடு",
      placeholders: { name: "உங்கள் பெயர்", organization: "FPO, கூட்டுறவு, வங்கி, நிறுவனம்...", email: "name@organization.com", interest: "டிஸ்கவரி, மார்க்கெட்பிளேஸ், மதிப்பு சங்கிலி நிதி..." },
    },
    storySteps: ["கண்டறிதல்", "ஒத்துழைப்பு", "பரிவர்த்தனை", "சரிபார்க்கப்பட்ட தரவு", "நிதி", "வளர்ச்சி"],
    sections: {
      challenge: { eyebrow: "சவால்", title: "விவசாயம் உறவுகளால் இயங்குகிறது. பெரும்பாலான அமைப்புகள் தனித்தனியாக இயங்குகின்றன." },
      ecosystem: { eyebrow: "ஒரே சூழலமைப்பு. ஒவ்வொரு பங்கேற்பாளரும்.", title: "விவசாய நிறுவனங்கள், வர்த்தகம், நிதி மற்றும் மேற்பார்வைக்கான இணைந்த செயல்பாட்டு அடுக்கு." },
      journey: { eyebrow: "முக்கிய பிளாட்ஃபார்ம் ஓட்டம்", title: "கண்டறிதல் • ஒத்துழைப்பு • பரிவர்த்தனை", copy: "கண்டறிதல் வாய்ப்புகளை உருவாக்குகிறது. ஒத்துழைப்பு நம்பிக்கையை உருவாக்குகிறது. பரிவர்த்தனைகள் சரிபார்க்கப்பட்ட தரவை உருவாக்குகின்றன. அந்த தரவு நிதியை இயக்குகிறது. நிதி வளர்ச்சியை உருவாக்குகிறது." },
      commerce: { eyebrow: "மார்க்கெட்பிளேஸ் & வர்த்தகம்", title: "விவசாய வர்த்தகத்திற்காக கட்டப்பட்டது", copy: "கண்டறிதலிலிருந்து தொகுப்பு, ஒப்பந்தங்கள், ஆர்டர்கள் மற்றும் டிஜிட்டல் செட்டில்மெண்ட்கள் வரை நகரும் வர்த்தக செயல்பாட்டு அடுக்கு." },
      finance: { eyebrow: "மதிப்பு சங்கிலி நிதியமைப்பு", title: "உண்மையான விவசாய செயல்பாட்டை அடிப்படையாகக் கொண்ட நிதி", copy: "பாரம்பரிய கடன் அடமானத்தை சார்ந்தது. Valchain AgriHub விவசாய மதிப்பு சங்கிலியில் நடைபெறும் சரிபார்க்கப்பட்ட செயல்பாடுகள் மற்றும் பரிவர்த்தனைகளை அடிப்படையாகக் கொண்டு நிதியை இயக்குகிறது." },
      disbursement: { eyebrow: "நிகழ்வு அடிப்படையிலான நிதி விடுவிப்பு", title: "உண்மையான நிகழ்வுகள் நடந்தபோது நிதி விடுவிக்கப்படுகிறது", copy: "மூலதனம் முன்கூட்டியே முழுவதுமாக விடப்படாது; சரிபார்க்கப்பட்ட மைல்கற்களின் அடிப்படையில் விடுவிக்கப்படுகிறது." },
      traceability: { eyebrow: "தடமறிதல் & வெளிப்படைத்தன்மை", title: "ஒவ்வொரு பரிவர்த்தனையிலும் நம்பிக்கை" },
      governance: { eyebrow: "நிர்வாகம் & இணக்கம்", title: "நவீன நிறுவனங்களுக்கான டிஜிட்டல் நிர்வாகம்" },
      cooperatives: { eyebrow: "FPOகள் & கூட்டுறவுகளுக்காக", title: "கூட்டு விவசாயத்தை வலுப்படுத்துதல்" },
      impact: { eyebrow: "வளர்ச்சி & தாக்கம்", title: "முக்கியமான விளைவுகள்" },
      finalCta: { eyebrow: "ஒருங்கிணைந்த விவசாய சூழலமைப்பு", title: "வலுவான விவசாய மதிப்பு சங்கிலிகளை உருவாக்குங்கள்", copy: "விவசாயிகளை வலுப்படுத்துங்கள். நிறுவனங்களை வலுப்படுத்துங்கள். நிதியை திறக்குங்கள்." },
    },
    challenges: ["சிதறிய விவசாயிகள்", "தனிமைப்படுத்தப்பட்ட FPOகள்", "இணைக்கப்படாத கூட்டுறவுகள்", "குறைந்த சந்தை அணுகல்", "குறைந்த நிதி", "கைமுறை செயல்பாடுகள்", "வெளிப்படைத்தன்மை குறைவு", "தடமறிதல் குறைவு"],
    stakeholders: ["விவசாயிகள்", "FPOகள்", "கூட்டுறவுகள்", "வாங்குபவர்கள்", "உள்ளீட்டு வழங்குநர்கள்", "லாஜிஸ்டிக்ஸ் வழங்குநர்கள்", "வங்கிகள்", "NBFCகள்", "அரசு முகமைகள்"],
    journey: { கண்டறிதல்: ["விவசாயிகளை கண்டறிதல்", "வாங்குபவர்களை கண்டறிதல்", "வழங்குநர்களை கண்டறிதல்", "FPOகளை கண்டறிதல்", "கூட்டுறவுகளை கண்டறிதல்", "வாய்ப்புகளை கண்டறிதல்", "சூழலமைப்பு பங்காளிகளை கண்டறிதல்"], ஒத்துழைப்பு: ["கூட்டு கொள்முதல்", "பகிரப்பட்ட லாஜிஸ்டிக்ஸ்", "பங்காளி ஈடுபாடு", "குழு திட்டமிடல்", "தொடர்பு பணிப்பாய்வுகள்", "அறிவு பகிர்வு"], பரிவர்த்தனை: ["B2B மார்க்கெட்பிளேஸ்", "B2C மார்க்கெட்பிளேஸ்", "கொள்முதல்", "விற்பனை", "ஒப்பந்த மேலாண்மை", "டிஜிட்டல் கட்டணங்கள்", "செட்டில்மெண்ட்கள்", "தடமறிதல்", "நிர்வாக பதிவுகள்"] },
    commerceCapabilities: ["வாங்குபவர் கண்டறிதல்", "வழங்குநர் கண்டறிதல்", "தொகுப்பு", "கொள்முதல்", "மொத்த வர்த்தகம்", "ஒப்பந்த மேலாண்மை", "ஆர்டர் மேலாண்மை", "டிஜிட்டல் செட்டில்மெண்ட்கள்"],
    financeBenefits: ["மேம்பட்ட கடன் அணுகல்", "குறைந்த அபாயம்", "வேகமான வேலைநிறைவு மூலதனம்", "தரவு சார்ந்த மதிப்பீடு", "நிதி சேர்க்கை", "கடன் வழங்குநர் நம்பிக்கை அதிகரிப்பு"],
    disbursementMilestones: [["விவசாயி பதிவு", "ஆரம்ப நிதி விடுவிப்பு"], ["உள்ளீட்டு கொள்முதல்", "உள்ளீட்டு நிதி விடுவிப்பு"], ["பயிர் சரிபார்ப்பு", "வேலைநிறைவு மூலதனம் விடுவிப்பு"], ["தொகுப்பு முடிந்தது", "கொள்முதல் நிதி விடுவிப்பு"], ["வாங்குபவர் ஒப்பந்தம் கையெழுத்தானது", "வர்த்தக நிதி விடுவிப்பு"], ["விநியோகம் உறுதி", "செட்டில்மெண்ட் தொடக்கம்"], ["கட்டணம் பெறப்பட்டது", "சுழற்சி முடிந்தது"]],
    traceabilitySteps: ["பண்ணை பதிவு", "ஜியோ-டேக்கிங்", "உற்பத்தி கண்காணிப்பு", "தர சரிபார்ப்பு", "தொகுப்பு", "லாஜிஸ்டிக்ஸ்", "விநியோகம்", "செட்டில்மெண்ட்"],
    governanceCapabilities: ["உறுப்பினர் மேலாண்மை", "போர்டு மேலாண்மை", "ஆடிட் தடங்கள்", "அறிக்கையிடல்", "இணக்கம்", "வெளிப்படைத்தன்மை", "டிஜிட்டல் பதிவுகள்"],
    cooperativeOutcomes: ["மேம்பட்ட ஒருங்கிணைப்பு", "மேம்பட்ட நிர்வாகம்", "மேம்பட்ட சந்தை அணுகல்", "மேம்பட்ட நிதி", "மேம்பட்ட வெளிப்படைத்தன்மை", "நிலையான வளர்ச்சி"],
    impactMetrics: [["விவசாயி வளம்", "இணைக்கப்பட்ட தேவையால் வலுவான வருமானம்"], ["சந்தை அணுகல்", "வாங்குபவர்கள் மற்றும் வழங்குநர்களுக்கான சரிபார்க்கப்பட்ட கண்டறிதல்"], ["நிறுவன வளர்ச்சி", "FPOகள் மற்றும் கூட்டுறவுகள் நம்பிக்கையுடன் செயல்படுதல்"], ["நிதி சேர்க்கை", "உண்மையான செயல்பாட்டு தரவின் அடிப்படையில் கடன்"], ["மதிப்பு சங்கிலி திறன்", "குறைந்த மீளுருவாக்கம், வேகமான இயக்கம்"], ["பரிவர்த்தனை வெளிப்படைத்தன்மை", "ஒவ்வொரு மைல்கல்லிலும் நிர்வகிக்கப்பட்ட பதிவுகள்"]],
  },
};

export const challenges = [
  "Fragmented farmers",
  "Isolated FPOs",
  "Disconnected cooperatives",
  "Poor market access",
  "Limited financing",
  "Manual operations",
  "Lack of transparency",
  "Lack of traceability",
];

export const journey = {
  Discover: [
    "Discover farmers",
    "Discover buyers",
    "Discover suppliers",
    "Discover FPOs",
    "Discover cooperatives",
    "Discover opportunities",
    "Discover ecosystem partners",
  ],
  Collaborate: [
    "Collective procurement",
    "Shared logistics",
    "Stakeholder engagement",
    "Group planning",
    "Communication workflows",
    "Knowledge sharing",
  ],
  Transact: [
    "B2B Marketplace",
    "B2C Marketplace",
    "Procurement",
    "Sales",
    "Contract Management",
    "Digital Payments",
    "Settlements",
    "Traceability",
    "Governance Records",
  ],
};

export const commerceCapabilities = [
  "Buyer Discovery",
  "Supplier Discovery",
  "Aggregation",
  "Procurement",
  "Bulk Trading",
  "Contract Management",
  "Order Management",
  "Digital Settlements",
];

export const financeEvents = [
  "Farmer",
  "Production",
  "Aggregation",
  "Procurement",
  "Logistics",
  "Buyer Contract",
  "Payment",
];

export const financeBenefits = [
  "Better credit access",
  "Reduced risk",
  "Faster working capital",
  "Data-driven underwriting",
  "Financial inclusion",
  "Greater lender confidence",
];

export const disbursementMilestones = [
  ["Farmer Registration", "Initial Disbursement"],
  ["Input Purchase", "Input Finance Released"],
  ["Crop Verification", "Working Capital Released"],
  ["Aggregation Completed", "Procurement Finance Released"],
  ["Buyer Contract Signed", "Trade Finance Released"],
  ["Delivery Confirmed", "Settlement Triggered"],
  ["Payment Received", "Cycle Completed"],
];

export const traceabilitySteps = [
  "Farm Registration",
  "Geo-tagging",
  "Production Tracking",
  "Quality Verification",
  "Aggregation",
  "Logistics",
  "Delivery",
  "Settlement",
];

export const governanceCapabilities = [
  "Member Management",
  "Board Management",
  "Audit Trails",
  "Reporting",
  "Compliance",
  "Transparency",
  "Digital Records",
];

export const cooperativeOutcomes = [
  "Better coordination",
  "Better governance",
  "Better market access",
  "Better financing",
  "Better transparency",
  "Sustainable growth",
];

export const impactMetrics = [
  ["Farmer Prosperity", "Stronger incomes through connected demand"],
  ["Market Access", "Verified discovery for buyers and suppliers"],
  ["Institutional Growth", "FPOs and cooperatives operating with confidence"],
  ["Financial Inclusion", "Credit enabled by real activity data"],
  ["Value Chain Efficiency", "Less duplication, faster movement"],
  ["Transaction Transparency", "Governed records across every milestone"],
];